import {Directive, ElementRef, Input, OnChanges, OnInit, SimpleChanges, inject} from '@angular/core';
import {MediaUrlPipe} from '../pipes/media-url.pipe';

@Directive({
  selector: '[appVideoSrc]',
  standalone: true
})
export class VideoSrcDirective implements OnInit, OnChanges {
  private el: ElementRef<HTMLSourceElement> = inject(ElementRef);
  private mediaUrlPipe: MediaUrlPipe = new MediaUrlPipe();

  @Input() public fileName: string | undefined = undefined;

  public ngOnInit(): void {
    this.updateSource();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['fileName']) {
      this.updateSource();
    }
  }

  private updateSource(): void {
    if (!this.fileName) {
      this.el.nativeElement.src = '';
      return;
    }

    const securedUrl = this.mediaUrlPipe.transform(this.fileName);
    if (securedUrl) {
      this.el.nativeElement.src = securedUrl;
      this.attachVideoListeners();
      this.parentVideoElement()?.load();
    }
  }

  private attachVideoListeners(): void {
    const videoElement = this.parentVideoElement();
    if (!videoElement) {
      return;
    }
  }

  private parentVideoElement(): HTMLVideoElement | null {
    const parentElement = this.el.nativeElement.parentElement;
    return parentElement instanceof HTMLVideoElement ? parentElement : null;
  }
}
